import { modalRenderer } from '~/modal/modalRendererRegistry';
import {
  PurchaseDataPackageModalComponent, type PurchaseDataPackageProps,
} from '~/purchaseDataPackage/modal/purchaseDataPackageModal.component';

declare module '~/modal/modalRegistry.type' {
  interface ModalComponentRegistry {
    PurchaseDataPackage: PurchaseDataPackageProps;
  }
}

modalRenderer.register('PurchaseDataPackage', PurchaseDataPackageModalComponent);
